import { makeStyles } from '@material-ui/core/styles';
import Constants from '../../Constants'

export const useConfirmationStyle = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        boxShadow: '0 3px 20px rgba(0,0,0,.14118) !important',
        borderRadius: '9px ',
        [theme.breakpoints.up(1000 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
    },
    eirConfirmaton: {
        '& a': {
            color: '#fff',
            textDecoration: 'none',
        },
        '& .confirmIcon': {
            margin: theme.spacing(4, 0, 2),
            '@media (max-width: 767px)': {
                margin: theme.spacing(3, 0),
            },
        },
        '& .leftPadding': {
            // paddingLeft: theme.spacing(5),
            textAlign: 'center',
        },

        '& h1': {
            fontSize: '40px',
            textAlign: 'left',
            marginTop: '24px',           
            '@media (max-width: 767px)': {
                fontSize: '35px',
            },
        },
        '& .confirmationContent': {
            margin: 'auto',
            width: '50%',
            textAlign: 'center',
            '@media (max-width: 767px)': {
                width: '100%',
            },
            '& p': {
                fontSize: '20px',
                color: '#25262A',
                '@media (max-width: 767px)': {
                    fontSize: '16px',
                },
            },
            '& h1': {
                marginTop: '0px',
                textAlign: 'center',
                marginBottom: '1.5rem',
            },
        },
        '& button': { outline: 'none' },
        '& .pupleBtn': {
            borderRadius: '2rem',
            fontSize: 18,
            textTransform: 'initial',
            padding: theme.spacing(1, 6),
            border: '1px solid '+Constants.siteTheme.primaryTheme,
            background: Constants.siteTheme.primaryTheme,
            color: '#fff',
            marginBottom: theme.spacing(3),
            fontFamily: 'eir-bold !important',
            '@media (max-width: 767px)': {
                float: 'none',
                padding: theme.spacing(1, 4),
            },
            '&:focus,&:hover': {
                outline: 'none',
            },
        },
        '& .boldFont': {
            fontFamily: 'eir-bold',
        }
    },
}));
